import { call } from '../core'

export interface INotiResponseParams {
  message: string
  duration?: number
}

export function showNotification(params: INotiResponseParams) {
  call('finShowNotification', params)
}
